import React from 'react';
import axios from 'axios';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import AutoSendSetting from './auto_send_setting';

jest.mock('axios');

describe('AutoSendSetting', () => {
  const videoStartRemindTimeOptions = { '5分前': 5,
                                        '10分前': 10,
                                        '15分前': 15,
                                        '30分前': 30,
                                        '60分前': 60}
  const paymentCompletionTemplate = {
    auto_send_enabled: 0,
    id: 1,
    m_institution_id: 2,
    message: "%{name}様\n\n%{scheduled_start_at}のオンライン服薬指導の予約において、クレジットカード決済が完了いたしました。\n\nご利用いただきましてありがとうございました。",
    message_kbn: 4,
    message_name: "クレジットカード決済完了時",
    video_start_remind_time: null
  }
  const videoStartTemplate = {
    auto_send_enabled: 0,
    id: 2,
    m_institution_id: 2,
    message: "%{name}様\n\n%{scheduled_start_at}にて予約されているオンライン服薬指導を開始いたします。",
    message_kbn: 5,
    message_name: "ビデオ通話開始リマインド時",
    video_start_remind_time: 5
  }

  const paymentFailedTemplate = {
    auto_send_enabled: 0,
    id: 3,
    m_institution_id: 2,
    message: "%{name}様\n\n%{scheduled_start_at}のオンライン服薬指導の予約において、クレジットカード決済が失敗しました。\nエラーメッセージ：%{agency_failure_message}\n\nご確認の程よろしくお願いいたします。",
    message_kbn: 7,
    message_name: "クレジットカード決済失敗時",
    video_start_remind_time: null
  }

  const paymentInProcessTemplate = {
    auto_send_enabled: 0,
    id: 4,
    m_institution_id: 2,
    message: "%{name}様\n\n%{scheduled_start_at}のオンライン服薬指導の予約において、クレジットカード決済は処理中です。\n\nご確認の程よろしくお願いいたします。",
    message_kbn: 8,
    message_name: "クレジットカード決済処理中",
    video_start_remind_time: null
  }


  test('renders AutoSendSetting component', async () => {
    render(<AutoSendSetting
             videoStartRemindTimeOptions={videoStartRemindTimeOptions}
             paymentCompletionTemplate={null}
             videoStartTemplate={null}
             setPaymentCompletionTemplate={null}
             setVideoStartTemplate={null}
             paymentFailedTemplate={null}
             setPaymentFailedTemplate={null}
             paymentInProcessTemplate={null}
             setPaymentInProcessTemplate={null}
          />);

    expect(screen.getByText('自動送信設定')).toBeInTheDocument();
    expect(screen.queryByText('クレジットカード決済完了時')).toBeNull();
    expect(screen.queryByText('ビデオ通話開始リマインド時')).toBeNull();
  });

  test('renders AutoSendSetting component', async () => {

    render(<AutoSendSetting
             videoStartRemindTimeOptions={videoStartRemindTimeOptions}
             paymentCompletionTemplate={paymentCompletionTemplate}
             videoStartTemplate={videoStartTemplate}
             setPaymentCompletionTemplate={() => {}}
             setVideoStartTemplate={() => {}}
             paymentFailedTemplate={paymentFailedTemplate}
             setPaymentFailedTemplate={() => {}}
             paymentInProcessTemplate={paymentInProcessTemplate}
             setPaymentInProcessTemplate={() => {}}
          />);

    expect(screen.getByText('自動送信設定')).toBeInTheDocument();
    expect(screen.getByText('クレジットカード決済完了時')).toBeInTheDocument();
    expect(screen.getByText('ビデオ通話開始リマインド時')).toBeInTheDocument();
    expect(screen.getByText('クレジットカード決済失敗時')).toBeInTheDocument();
    expect(screen.getByText('クレジットカード決済処理中')).toBeInTheDocument();
  });
});
